export default __webpack_public_path__ + "static/media/screen1.3dbd5828.jpg";